import { truthy } from 'shared/helpers/typeHelper'

import { getRequest } from './common'

export function getZendeskTickets({ query = '', email = '', created_before = '', created_after = '' }) {
  let url = `/api/v1/console/zendesk-tickets/`
  let params = new URLSearchParams(
    [
      query ? ['query', query] : undefined,
      email ? ['email', email] : undefined,
      created_before ? ['created_before', created_before] : undefined,
      created_after ? ['created_after', created_after] : undefined,
    ].filter(truthy)
  ).toString()

  return getRequest(`${url}?${params}`)
}
